export const DELIVERY_PRICES = {
  SELF_ASSEMBLY: 89,
  ZAKELIJK: 89,
} as const;
